package io.horion.cv.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.px

val ConfirmPageContainerStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .padding(top = 30.px, bottom = 30.px, leftRight = 40.px)
    }
    Breakpoint.MD {
        Modifier.padding(top = 50.px, bottom = 70.px, leftRight = 60.px)
    }
    Breakpoint.LG {
        Modifier
            .width(1100.px)
            .padding(top = 60.px, bottom = 100.px, leftRight = 0.px)
    }
}

val ConfirmHeaderRowStyle = CssStyle {
    base { Modifier.margin(bottom = 30.px) }
    Breakpoint.MD { Modifier.margin(bottom = 60.px) }
    Breakpoint.LG { Modifier.margin(bottom = 120.px) }
}

val ConfirmBackIconStyle = CssStyle {
    base { Modifier.fontSize(20.px) }
    Breakpoint.MD { Modifier.fontSize(26.px) }
    Breakpoint.LG { Modifier.fontSize(32.px) }
}

val ConfirmTitleStyle = CssStyle {
    base { Modifier.fontSize(18.px) }
    Breakpoint.MD { Modifier.fontSize(24.px) }
    Breakpoint.LG { Modifier.fontSize(30.px) }
}

val ConfirmContentWrapperStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .gap(30.px)
            .styleModifier {
                property("display", "flex")
                property("flex-direction", "column")
                property("align-items", "center")
            }
    }
    Breakpoint.MD {
        Modifier.styleModifier {
            property("display", "flex")
            property("flex-direction", "row")
            property("justify-content", "space-between")
            property("align-items", "flex-start")
        }
    }
}

val ConfirmFormSectionStyle = CssStyle {
    base { Modifier.fillMaxWidth() }
    Breakpoint.MD { Modifier.width(300.px) }
}

val ConfirmFormLabelStyle = CssStyle {
    base { Modifier.fontSize(14.px) }
    Breakpoint.MD { Modifier.fontSize(16.px) }
    Breakpoint.LG { Modifier.fontSize(20.px) }
}

val ConfirmOperatorCardStyle = CssStyle {
    base {
        Modifier
            .width(200.px)
            .height(60.px)
            .margin(bottom = 24.px)
    }
    Breakpoint.MD {
        Modifier
            .width(220.px)
            .height(70.px)
            .margin(bottom = 30.px)
    }
    Breakpoint.LG {
        Modifier
            .width(280.px)
            .height(80.px)
            .margin(bottom = 50.px)
    }
}

val ConfirmOrangeImageStyle = CssStyle {
    base {
        Modifier
            .width(100.px)
            .height(40.px)
    }
    Breakpoint.MD {
        Modifier
            .width(160.px)
            .height(55.px)
    }
}

val ConfirmMtnImageStyle = CssStyle {
    base {
        Modifier
            .width(80.px)
            .height(40.px)
    }
    Breakpoint.MD {
        Modifier
            .width(130.px)
            .height(55.px)
    }
}

val ConfirmPhoneDisplayTextStyle = CssStyle {
    base {
        Modifier
            .fontSize(14.px)
            .margin(bottom = 30.px)
    }
    Breakpoint.MD {
        Modifier
            .fontSize(16.px)
            .margin(bottom = 50.px)
    }
    Breakpoint.LG {
        Modifier
            .fontSize(18.px)
            .margin(bottom = 80.px)
    }
}

val ConfirmButtonStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .height(48.px)
            .fontSize(18.px)
    }
    Breakpoint.MD {
        Modifier
            .width(460.px)
            .height(52.px)
            .fontSize(20.px)
    }
    Breakpoint.LG {
        Modifier
            .width(570.px)
            .height(60.px)
            .fontSize(25.px)
    }
}